/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import axios from 'axios';
import config from '../config/profileCard.config.json';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_MY_ORGANIZATION } from '../graphql';
import { VApplication } from '@/application';

import { AppNavigatorService } from '@/AppNavigator';

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.AppNavigatorService') as AppNavigatorService;
};

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface IProfileCardMethods extends IPluginMethodMap {
  getProfileCardProps(args: any): Promise<any>;
}

export class ProfileCardService implements IAgentPlugin {
  readonly methods: IProfileCardMethods;

  constructor() {
    this.methods = {
      getProfileCardProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    // const graphqlModule = getGraphQLModule();
    // const client = graphqlModule.getClient("graphql-gateway");
    // try {
    //   if (client) {
    //     const res = await client.query({
    //       query: GET_MY_ORGANIZATION,
    //       fetchPolicy: "network-only",
    //     });
    //     if (res?.data) {
    //       console.log(`profile data`, res.data);
    //       const _data: any = await this.getFormattedProfile(
    //         res.data?.getMyOrgProfile
    //       );
    //       return {
    //         ...(_data || {}),
    //       };
    //     }
    //   }
    // } catch (err: any) {
    //   throw err;
    // }
    return { ...(config || {}) };
  }

  private async getFormattedProfile(data: any) {
    let _profileInfo: any = {
      title: null,
      subtitle: null,
      image: data?.logo,
      profileInfo: [
        {
          label: 'Email',
          value: '',
        },
        {
          label: 'Contact No.',
          value: '',
        },
        {
          label: 'Address',
          value: '',
        },
        {
          label: 'Website',
          value: '',
        },
      ],
      defaultName: data?.name,
      defaultDescription: data?.description,
      defaultEmail: data?.email,
      defaultAddress: data?.address?.addressLine1,
      defaultPhoneNumber: data?.telephone,
      defaultWebsite: data?.website,
      editButtonDisabled: await this.isEditEnabled(),
      defaultProfileImg: data?.logo,
    };
    if (data?.name) {
      _profileInfo.title = data?.name;
    }
    if (data?.description) {
      _profileInfo.subtitle = data?.description;
    }
    _profileInfo.profileInfo?.map((item: any, index: number) => {
      if (item?.label === 'Email') {
        item.value = data?.email;
      } else if (item?.label === 'Address') {
        item.value = data?.address?.addressLine1;
      } else if (item?.label === 'Website') {
        item.value = data?.website;
      } else if (item?.label === 'Contact No.') {
        item.value = data?.telephone;
      }
      return item;
    });
    return _profileInfo;
  }

  private async isEditEnabled() {
    const srv = getWhoamiSrv();
    const user = await srv?.whoAmI();
    console.log(`user in profile service`, user);
    let formatted = true;
    if (user?.whoami === 'admin') {
      formatted = false;
    }
    return formatted;
  }
}
